export default __webpack_public_path__ + "static/media/email-lightBlue.f12f2473.svg";